import { render, staticRenderFns } from "./areaPasswordForgotten.vue?vue&type=template&id=49e9568c&scoped=true&"
import script from "./areaPasswordForgotten.vue?vue&type=script&lang=js&"
export * from "./areaPasswordForgotten.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49e9568c",
  null
  
)

export default component.exports